import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2AE3707D-5DE3-41E6-968B-A56D3D9ADD40
 * name message-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-outline.svg
 * tags
 */
export const MessageOutlineIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16Z" /></>, 'MessageOutlineIcon');
export default MessageOutlineIcon